import { Button } from '@/components/ui/button';

interface PersonaEmptyStateProps {
	onGetStarted: () => void;
}

export function PersonaEmptyState({ onGetStarted }: PersonaEmptyStateProps) {
	return (
		<div className='absolute inset-0 flex flex-col items-center justify-center gap-5 text-center'>
			<img src='/assets/persona/lego-blocks.svg' alt='' className='w-[395px]' />
			<div className='max-w-md flex flex-col items-center gap-1.5'>
				<h2 className='text-sm font-semibold'>Set Up Persona</h2>
				<p className='text-xs text-muted-foreground'>
					Set up behaviors. Look back at past tickets to spot patterns, then turn them into rules tailored to your
					brand voice or your agents.
				</p>
			</div>
			<Button onClick={onGetStarted} className='rounded-full'>
				Get started
			</Button>
		</div>
	);
}
